// extracted by mini-css-extract-plugin
module.exports = {"root":"copyright_root__1Rvox","link":"copyright_link__fsL02","text":"copyright_text__1zsaS","nav":"copyright_nav__1_1l-"};